/**
 * Kent LDAP Auth (Selling Guide gate)
 *
 * Session:
 *   - Refresh: stays logged in
 *   - Hard refresh: stays logged in
 *   - Same tab: stays logged in
 *   - New tab: login required
 *   - Tab closed: session is cleared
 */
(function () {
  "use strict";

  var LDAP_URL = "https://automations.kent.co.in/ldap_authenticate.php";
  var STORAGE_KEY = "kent_guide_ldap_session";

  /**
   * LDAP login
   */
  async function login(username, password) {
    var response;

    try {
      response = await fetch(LDAP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username: username,
          password: password
        })
      });
    } catch (networkErr) {
      return {
        success: false,
        message: "Could not reach the login service. Try again shortly."
      };
    }

    var data = {};

    try {
      data = await response.json();
    } catch (parseErr) {
      return {
        success: false,
        message: "Unexpected response from the login service."
      };
    }

    return {
      success: !!data.success,
      message:
        data.message ||
        (data.success
          ? "Login successful"
          : "Invalid username or password"),
      username: data.username || username
    };
  }

  /**
   * Save session for CURRENT TAB.
   *
   * sessionStorage survives:
   *   - refresh
   *   - hard refresh
   *   - navigation in same tab
   *
   * It is not shared with a new tab.
   */
  function saveSession(username) {
    var payload = {
      username: username,
      loggedIn: true,
      createdAt: Date.now()
    };

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(payload)
      );
    } catch (e) {
      console.error("Could not save LDAP session:", e);
    }
  }

  /**
   * Get current tab session.
   */
  function getSession() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);

      if (!raw) {
        return null;
      }

      var payload = JSON.parse(raw);

      if (
        !payload ||
        payload.loggedIn !== true ||
        !payload.username
      ) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return payload;

    } catch (e) {
      console.error("Could not read LDAP session:", e);
      return null;
    }
  }

  /**
   * Clear current tab session.
   */
  function clearSession() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error("Could not clear LDAP session:", e);
    }
  }

  /**
   * Logout.
   *
   * Clears current tab session and redirects
   * to Shopify store base URL.
   */
  function logout() {
    clearSession();

    window.location.href = "/";
  }

  /**
   * Expose API globally.
   */
  window.KentLDAPAuth = {
    login: login,
    saveSession: saveSession,
    getSession: getSession,
    clearSession: clearSession,
    logout: logout
  };

})();